import React from 'react';
import {
  Col,
  Row
} from 'reactstrap';
import { IconWidget } from 'components/Widget';

import Skeleton from '@mui/material/Skeleton';
import {
  MdCampaign,
  MdDrafts,
  MdOutlinePending,
  MdApproval,
  MdOutlinePauseCircleOutline,
  MdDoneAll,
  MdOutlineAdsClick,
  MdShare,
  MdVisibility,
  MdThumbUp,
  MdBookmark,
  MdComment,
  MdPaid
} from 'react-icons/md';
import { deciamNumberFormat } from 'hooks';
import MultiAxisLineChart from '../../components/chart/multi-axis-line';
import ChartjsChartGeo from './chartjs-chart-geo';
import { CONSTANTS } from '../../constants';
import CampaignLocationMap from './campaign.location.map'
function CampaignAnalytics(props) {

  const dataBoxes = [
    {
      icon: MdPaid,
      title: 'Debit Transaction',
      subtitle: CONSTANTS.CURRENCY + ((props.campaignAnalytics && props.campaignAnalytics.transactions) ? deciamNumberFormat(props.campaignAnalytics.transactions.debit, 2) : 0.00)
    },
    {
      icon: MdPaid,
      title: 'Credit Tranaction',
      subtitle: CONSTANTS.CURRENCY + ((props.campaignAnalytics && props.campaignAnalytics.transactions) ? deciamNumberFormat(props.campaignAnalytics.transactions.credit, 2) : 0.00)
    },

    {
      icon: MdCampaign,
      title: 'Total Campaigns',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.total_campaigns) ? props.campaignAnalytics.total_campaigns.total : 0)
    },
    {
      icon: MdDrafts,
      title: 'Total Campaigns in Draft',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.total_campaigns) ? props.campaignAnalytics.total_campaigns.Draft : 0)
    },
    {
      icon: MdOutlinePending,
      title: 'Total Pending Campaigns',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.total_campaigns) ? props.campaignAnalytics.total_campaigns.Pending : 0)
    },
    {
      icon: MdApproval,
      title: 'Total Approved Campaigns',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.total_campaigns) ? props.campaignAnalytics.total_campaigns.Approved : 0)
    },
    {
      icon: MdOutlinePauseCircleOutline,
      title: 'Total Paused Campaigns',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.total_campaigns) ? props.campaignAnalytics.total_campaigns.Paused : 0)
    },
    {
      icon: MdDoneAll,
      title: 'Total Completed Campaigns',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.total_campaigns) ? props.campaignAnalytics.total_campaigns.Completed : 0)
    },
    {
      icon: MdOutlineAdsClick,
      title: 'Total Clicks on Campaigns',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.total_clicks_campaigns) ? props.campaignAnalytics.total_clicks_campaigns : 0)
    },
    {
      icon: MdBookmark,
      title: 'Total Campaigns Bookmarked',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.total_bookmarks_campaigns) ? props.campaignAnalytics.total_bookmarks_campaigns : 0)
    },
    {
      icon: MdShare,
      title: 'Total Campaigns Shared',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.total_shared_campaigns) ? props.campaignAnalytics.total_shared_campaigns : 0)
    },
    {
      icon: MdComment,
      title: 'Total Comments on Campaigns',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.total_comments_campaigns) ? props.campaignAnalytics.total_comments_campaigns : 0)
    },
    {
      icon: MdThumbUp,
      title: 'Total Likes on Campaigns',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.total_likes_campaigns) ? props.campaignAnalytics.total_likes_campaigns : 0)
    },
    {
      icon: MdVisibility,
      title: 'Total Impressions on Campaigns',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.total_viewed_campaigns) ? props.campaignAnalytics.total_viewed_campaigns : 0)
    },
    {
      icon: MdShare,
      title: 'Total Users Shared Campaigns',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.users_shared_campaigns) ? props.campaignAnalytics.users_shared_campaigns : 0)
    },
    {
      icon: MdOutlineAdsClick,
      title: 'Total Users clicked on Campaigns',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.users_clicks_campaigns) ? props.campaignAnalytics.users_clicks_campaigns : 0)
    },
    {
      icon: MdVisibility,
      title: 'Total Users Viewed Campaigns',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.users_views_campaigns) ? props.campaignAnalytics.users_views_campaigns : 0)
    },
    {
      icon: MdBookmark,
      title: 'Total Users Bookmarked Campaigns',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.users_bookmarks_campaigns) ? props.campaignAnalytics.users_bookmarks_campaigns : 0)
    },
    {
      icon: MdComment,
      title: 'Total Users Commented on Campaigns',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.users_comments_campaigns) ? props.campaignAnalytics.users_comments_campaigns : 0)
    },

    {
      icon: MdThumbUp,
      title: 'Total Users Liked Campaigns',
      subtitle: parseInt((props.campaignAnalytics && props.campaignAnalytics.users_likes_campaigns) ? props.campaignAnalytics.users_likes_campaigns : 0)
    }
  ];

  const generateWidget = () => {
    return dataBoxes.map((item, index) => (
      <Col lg={3} md={6} sm={6} xs={12} key={`widget-${index}`}>
        {(props.isLoading) ? <Skeleton variant="rect" height="auto" width="100%" animation="wave">
          <IconWidget />
        </Skeleton>
          : <IconWidget
            bgColor={'light'}
            icon={item.icon}
            title={item.title}
            subtitle={item.subtitle}
          />
        }
      </Col>
    )
    )
  }
  return (
    <div>
      <Row>
        {generateWidget()}
      </Row>
      <Row style={{ padding: 10, color: '#3aacd6' }}>
        <h5><MdPaid />Transactions</h5>
      </Row>
      <Row style={{ height: 400, padding: 10 }}>
        <Col lg={12} md={12} sm={12} xs={12} className="boxShadow" style={{ padding: 10 }}>
          <MultiAxisLineChart data={props.transactionGraphData} />
        </Col>
      </Row>

      <Row style={{ padding: 10, color: '#3aacd6' }}>
        <h5><MdCampaign /> Active Campaigns</h5>
      </Row>
      <Row style={{ height: 400, padding: 10 }}>
        <Col lg={12} md={12} sm={12} xs={12} className="boxShadow" style={{ padding: 10 }}>
          <ChartjsChartGeo data={props.activeCampaignsMap} />
        </Col>

      </Row>

      <Row style={{ height: 500, padding: 10 }}>
        <Col lg={12} md={12} sm={12} xs={12} className="boxShadow" style={{ padding: 10 }}>
          <CampaignLocationMap data={props.activeCampaignsLocal} width={'96%'} height={'460px'} key={(Math.random() + 1).toString(36).substring(7)} />
        </Col>
      </Row>


    </div>
  );
}
export default CampaignAnalytics;